import { render, staticRenderFns } from "./task-note-detail.vue?vue&type=template&id=1352ab1f&"
import script from "./task-note-detail.vue?vue&type=script&lang=js&"
export * from "./task-note-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1352ab1f')) {
      api.createRecord('1352ab1f', component.options)
    } else {
      api.reload('1352ab1f', component.options)
    }
    module.hot.accept("./task-note-detail.vue?vue&type=template&id=1352ab1f&", function () {
      api.rerender('1352ab1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-note-detail.vue"
export default component.exports